<template>
  <div class="top_horizontal_cls">
    <div class="logo_cls">
      <img :src="logoImg" class="logo_img" />
    </div>
    <div class="line"></div>
    <div :class="language === 'zh' ? 'sh-box' : 'sh-box-en'">
      <div class="text">{{ $t('footer.shCode') }}</div>
      <div class="text1">603897.SH</div>
    </div>
    <div style="flex:1;"></div>
    <el-row class="bar_cls">
      <!-- 首页 -->
      <el-col :span="6" class="bar_item">
        <div :class="path == '/home' ? 'bar_text_active' : 'bar_text'">
          <router-link to="/home" key="home">
            <span class="esp_text">{{ $t('navbar.home') }}</span>
          </router-link>
        </div>
        <div v-if="path == '/home'" class="active_cls"></div>
      </el-col>

      <!-- 关于长城 -->
      <el-col :span="6" class="bar_item">
        <div :class="path == '/abort' ? 'bar_text_active abort-data-select' : 'bar_text abort-data-select'">
          <router-link to="/abort" key="abort">
            <span class="esp_text">{{ $t('navbar.abortGreatWall') }}</span>
          </router-link>
          <div class="abort-data-select-box">
            <router-link to="/abort?location=company-introduction-box" key="abort1">
              <div :class="location == 'company-introduction-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.companyIntroduction') }}
              </div>
            </router-link>
            <!-- <router-link to="/abort?location=development-history-box" key="abort2">
              <div :class="location == 'development-history-box' ? 'data-select-item-active' : 'data-select-item'">{{
        $t('navbar.developmentHistory') }}</div>
            </router-link> -->
            <router-link to="/abort?location=honorary-qualifications-box" key="abort3">
              <div :class="location == 'honorary-qualifications-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.honoraryQualifications') }}
              </div>
            </router-link>
            <router-link to="/abort?location=corporate-culture-box" key="abort4">
              <div :class="location == 'corporate-culture-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.corporateCulture') }}
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="path == '/abort'" class="active_cls"></div>
      </el-col>

      <!-- 产品服务 -->
      <el-col :span="6" class="bar_item">
        <div
          :class="path.includes('/services') ? 'bar_text_active services-data-select' : 'bar_text services-data-select'">
          <router-link to="/services" key="services">
            <span class="esp_text">{{ $t('navbar.productServices') }}</span>
          </router-link>
          <div class="services-data-select-box">
            <router-link to="/services?location=round-wire-products-box" key="services1">
              <div :class="location == 'round-wire-products-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.roundWireProducts') }}
              </div>
            </router-link>
            <router-link to="/services?location=flat-wire-products-box" key="services2">
              <div :class="location == 'flat-wire-products-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.flatWireProducts') }}
              </div>
            </router-link>
            <router-link to="/services?location=application-area-box" key="services3">
              <div :class="location == 'application-area-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.applicationArea') }}
              </div>
            </router-link>
            <router-link to="/services?location=partners-box" key="services4">
              <div :class="location == 'partners-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.partners') }}
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="path.includes('/services')" class="active_cls"></div>
      </el-col>

      <!-- 长城力量 -->
      <el-col :span="6" class="bar_item">
        <div :class="path == '/power' ? 'bar_text_active power-data-select' : 'bar_text power-data-select'">
          <router-link to="/power" key="power">
            <span class="esp_text">{{ $t('navbar.greatWallPower') }}</span>
          </router-link>
          <div class="power-data-select-box">
            <router-link to="/power?location=research-strength-box" key="power1">
              <div :class="location == 'research-strength-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.researchStrength') }}
              </div>
            </router-link>
            <router-link to="/power?location=advanced-equipment-box" key="power2">
              <div :class="location == 'advanced-equipment-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.advancedEquipment') }}
              </div>
            </router-link>
            <router-link to="/power?location=quality-assurance-box" key="power3">
              <div :class="location == 'quality-assurance-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.qualityAssurance') }}
              </div>
            </router-link>
            <router-link to="/power?location=authoritative-certification-box" key="power4">
              <div
                :class="location == 'authoritative-certification-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.authoritativeCertification') }}
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="path == '/power'" class="active_cls"></div>
      </el-col>

      <!-- 新闻资讯 -->
      <el-col :span="6" class="bar_item">
        <div :class="path.includes('/news') ? 'bar_text_active news-data-select' : 'bar_text news-data-select'">
          <router-link to="/news" key="news">
            <span class="esp_text">{{ $t('navbar.newsInformation') }}</span>
          </router-link>
          <div class="news-data-select-box">
            <router-link to="/news?tab=0" key="news0">
              <div :class="location == 'company-information-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.companyInformation') }}
              </div>
            </router-link>
            <router-link to="/news?tab=1" key="news1">
              <div :class="location == 'industry-news-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.industryNews') }}
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="path.includes('/news')" class="active_cls"></div>
      </el-col>

      <!-- 加入我们 -->
      <el-col :span="6" class="bar_item">
        <div
          :class="path.includes('/contact') ? 'bar_text_active contact-data-select' : 'bar_text contact-data-select'">
          <router-link to="/contact" key="contact">
            <span class="esp_text">{{ $t('navbar.joinUs') }}</span>
          </router-link>
          <div class="contact-data-select-box">
            <router-link to="/contact?location=contact-us-box" key="contact1">
              <div :class="location == 'contact-us-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.contactUs') }}
              </div>
            </router-link>
            <router-link to="/contact?location=recruitment-information-box" key="contact2">
              <div :class="location == 'recruitment-information-box' ? 'data-select-item-active' : 'data-select-item'">
                {{ $t('navbar.recruitmentInformation') }}
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="path.includes('/contact')" class="active_cls"></div>
      </el-col>
    </el-row>

    <el-dropdown trigger="hover" class="international" @command="handleSetLanguage">
      <div>
        <img :src="languageImg" class="international-icon" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :disabled="language === 'zh'" command="zh">中文</el-dropdown-item>
        <el-dropdown-item :disabled="language === 'en'" command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>

import logoImg from '@/assets/images/logo.png'
import languageImg from '@/assets/images/language.png'
export default {
  name: 'layout',
  data() {
    return {
      logoImg, languageImg,
      path: this.$route.path,
      location: this.$route.query.location
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  watch: {
    $route: {
      handler(newRouter) {
        this.path = newRouter.path;
        this.location = newRouter.query.location;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      // console.info("change-language:" + lang);
      window.location.reload();
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.top_horizontal_cls {
  height: 10rem;
  display: flex;
  flex-direction: relative;
  width: 100%;
  background: transparent;
  align-items: center;

  .logo_cls {
    margin-left: 5rem;
    display: flex;
    height: 10rem;
    align-items: center;

    .logo_img {
      height: 4.5rem;
    }
  }

  .line {
    width: 1px;
    height: 4.5rem;
    background-color: #ffffffb3;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sh-box {
    height: 4.5rem;
    font-size: 2rem;
    font-family: "AdobeHeitiStd";
    color: #ffffffb3;

    .text {
      letter-spacing: 2px;
    }

    .text1 {
      letter-spacing: 1px;
    }
  }

  .sh-box-en {
    height: 4.5rem;
    font-size: 2rem;
    font-family: "AdobeHeitiStd";
    color: #ffffffb3;

    .text {
      letter-spacing: 2px;
    }

    .text1 {
      letter-spacing: 2.5px;
    }
  }

  .bar_cls {
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-right: 8.3rem;

    .bar_item {
      width: max-content;
      min-width: 18.4rem;
      text-align: center;
      position: relative;

      .bar_text {
        color: #fff;
        line-height: 13rem;
        font-weight: 600;
        font-size: 2rem;
        font-family: "AdobeHeitiStd";
        padding: 0 1em;

        &:hover {
          font-size: 2.3rem !important;
          color: #0089ff !important;
        }
      }

      .bar_text_active {
        line-height: 13rem;
        font-weight: 600;
        font-size: 2rem;
        font-family: "AdobeHeitiStd";
        color: #0089ff;
        font-family: "AdobeHeitiStd";
        padding: 0 1em;

        &:hover {
          font-size: 2.3rem !important;
          color: #0089ff !important;

          .active_cls {
            display: none !important;
          }
        }
      }
    }

    .active_cls {
      width: auto;
      min-width: 8rem;
      height: 4px;
      background-color: #005baa;
      position: absolute;
      top: 9.6rem;
      margin-left: 5.2rem;
    }
  }

  .data-select-item {
    width: 100%;
    height: 9rem;
    line-height: 9rem;
    color: #fff;
    font-size: 2rem;
    font-family: "AdobeHeitiStd";
    text-align: center;
    background-color: #000000a1;
    overflow: hidden;
    font-family: "AdobeHeitiStd";
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    padding: 0 1em;

    &:hover {
      width: 100%;
      height: 9rem;
      line-height: 9rem;
      color: #fff;
      font-size: 2rem;
      font-family: "AdobeHeitiStd";
      text-align: center;
      background-color: #005baa;
    }
  }

  .data-select-item-active {
    width: 100%;
    height: 9rem;
    line-height: 9rem;
    color: #fff;
    font-size: 2rem;
    font-family: "AdobeHeitiStd";
    text-align: center;
    background-color: #000000a1;
    overflow: hidden;
    font-family: "AdobeHeitiStd";
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */

    &:hover {
      width: 100%;
      height: 9rem;
      line-height: 9rem;
      color: #fff;
      font-size: 2rem;
      font-family: "AdobeHeitiStd";
      text-align: center;
      background-color: #005baa;
    }
  }

  .abort-data-select {
    position: relative;

    &:hover {
      .abort-data-select-box {
        display: block;
      }
    }

    .abort-data-select-box {
      position: absolute;
      width: max-content;
      min-width: 22rem;
      left: 2.6rem;
      top: 10rem;
      background-color: #000000a1;
      z-index: 1;
      display: none;
    }
  }

  .services-data-select {
    position: relative;

    &:hover {
      .services-data-select-box {
        display: block;
      }
    }

    .services-data-select-box {
      position: absolute;
      width: max-content;
      min-width: 22rem;
      left: 2.6rem;
      top: 10rem;
      background-color: #000000a1;
      z-index: 1;
      display: none;
    }
  }

  .power-data-select {
    position: relative;

    &:hover {
      .power-data-select-box {
        display: block;
      }
    }

    .power-data-select-box {
      position: absolute;
      width: max-content;
      min-width: 22rem;
      left: 2.6rem;
      top: 10rem;
      background-color: #000000a1;
      z-index: 1;
      display: none;
    }
  }

  .news-data-select {
    position: relative;

    &:hover {
      .news-data-select-box {
        display: block;
      }
    }

    .news-data-select-box {
      position: absolute;
      width: 22rem;
      left: 2.6rem;
      top: 10rem;
      background-color: #000000a1;
      z-index: 1;
      display: none;
    }
  }

  .contact-data-select {
    position: relative;

    &:hover {
      .contact-data-select-box {
        display: block;
      }
    }

    .contact-data-select-box {
      position: absolute;
      width: 22rem;
      left: 2.6rem;
      top: 10rem;
      background-color: #000000a1;
      z-index: 1;
      display: none;
    }
  }

  .international {
    position: absolute;
    right: 3rem;
    top: 3rem;

    .international-icon {
      width: 4rem;
      height: 4rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Layout/components/HeadeBar.vue